import React, { useEffect, useState } from 'react';

import { StyledCookieBanner } from './styles';

const onBannerDismiss = () => {
  localStorage.setItem('cookie-banner-hidden', '1');
};

export const CookieBanner: React.FC = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  useEffect(() => {
    const isHidden = localStorage.getItem('cookie-banner-hidden');
    setShowCookieBanner(isHidden === null ? true : false);
  }, []);
  return (
    <StyledCookieBanner
      data-testid="cookie-banner"
      className={showCookieBanner ? 'is-active' : ''}
    >
      <h6>This website uses cookies</h6>
      <div>
        <p>
          We use cookies to to analyse our traffic. We also share information
          about your use of our site with our social media and analytics
          partners who may combine it with other information that you've
          provided to them or that they've collected from your use of their
          services.
        </p>
        <button
          type="button"
          onClick={() => {
            onBannerDismiss();
            setShowCookieBanner(false);
          }}
        >
          OK
        </button>
      </div>
    </StyledCookieBanner>
  );
};
